const getContentTypeIsVideo = (contentType: string): boolean => {
   return !!contentType && contentType.split('/')[0].toLowerCase() === 'video';
};

export default {getContentTypeIsVideo};
